import { types } from './types';
import { instance } from '../utils';
import { setMetaCsrf } from '../../util/basicRenders';
import { omit } from 'lodash';

export const loginUser = ({email, password, callback}) => dispatch => {
  const url = '/api/user/login';
  dispatch({ type: types.GET_USER.START });
  instance
    .post(url, {email, password}, {
      headers: {
        "Cache-Control": "no-cache"
      }
    })
    .then(response => {
      const data = response?.data;

      dispatch({ type: types.GET_USER.SUCCESS, payload: omit(data, "csrft") });
      setMetaCsrf(data?.csrft);

      // If RAM token is included and valid, store it and redirect to the RAM internal audit app.
      // Expected shape: { success: true, error: null, data: { access_token, refresh_token, ... } }
      const ramToken = data?.ramToken;
      const hasValidRamToken =
        ramToken?.success === true &&
        ramToken?.error !== false &&
        !!ramToken?.data?.access_token &&
        !!ramToken?.data?.refresh_token;

      if (hasValidRamToken) {
        try {
          localStorage.setItem('ramToken', ramToken.data.access_token);
          localStorage.setItem('ramRefreshToken', ramToken.data.refresh_token);
        } catch (e) {

          console.error('Failed to persist RAM tokens to localStorage', e);
        }

        // If first login, don't redirect yet — let the user change their password first.
        // The RAM tokens are already stored; ChangePassword will redirect after password change.
        if (data?.firstLogin === true) {
          callback?.(false);
          return;
        }

        window.location.href = '/internal-audit/';
        return;
      }

      callback?.(false);
    })
    .catch(error => {
      dispatch({ type: types.GET_USER.ERROR, payload: error.message });
      callback(true)
    });
};

export const accountCheckerUser = (user) => dispatch => {
    dispatch({ type: types.GET_USER.START });
    dispatch({ type: types.GET_USER.SUCCESS, payload: user.data });
}

export const logoutUser = () => dispatch => {
    const url = '/api/user/logout';
    dispatch({ type: types.LOGOUT_USER.START });
    instance
    .get(url)
    .then(response => {
      dispatch({ type: types.GET_USER.SUCCESS });
      window.location.href = response.data;
    })
    .catch(error => {
      dispatch({ type: types.GET_USER.ERROR, payload: error.message });
    });
}

export const updateFirstLogin = ({callback}) => dispatch => {
  dispatch({ type: types.GET_USER.START });
  dispatch({ type: types.UPDATE_FIRST_LOGIN.SUCCESS });
  callback();
}
